import React, { Component } from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import orangeSymbol from "./../../images/mb/orange_symbol.png";
import GatsbyImage from "gatsby-image";

export default class ProjectThumbnail extends Component {
  render() {
    const { image, name, tags, link, tagMap, BG, hoverImg } = this.props;
    const formattedTags = tagMap
      .filter(a => tags.indexOf(a.node.name) >= 0)
      .map(a => a.node.name)
      .join(" | ");

    const Figure = styled.figure`
      color: red;
      &&:hover .gallery-img {
        background-image: url(${hoverImg.resolutions.src});
      }
    `;

    return (
      <li>
        <Figure>
          <div className="gallery-img">
            <Link to={`/projects/${link}`}>
              <img src={`${BG && BG.sizes.src}`} />
              {/* <GatsbyImage sizes={BG.sizes} /> */}
            </Link>
          </div>
          <figcaption>
            <h3>
              <img src={orangeSymbol} />
              {name}
            </h3>
            {/* <p dangerouslySetInnerHTML={{ __html: tags }} />
             */}
            <p>{formattedTags}</p>
          </figcaption>
        </Figure>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectThumbnail/index.js